import axios from '../http'; // 导入http中创建的axios实例
import qs from 'qs'; // 根据需求是否导入qs模块,post数据需要qs格式化
import base from './base'// 导入接口域名列表
//商品管理相关接口
const myAllWork={

  //列表数据--不用登陆直接使用
  webPage(params){
    // console.log("----我使用新的了-----"+params)
    return axios.post(`${base.bs}/goods/webPage`,qs.stringify(params));
  },
  //列表数据
  getPage(params){
    // console.log("----我使用新的了-----"+params)
    return axios.post(`${base.bs}/admin/tabGoods/page`,qs.stringify(params));
  },
  //根据id查询单个产品
  getById(params){
    return axios.get(`${base.bs}/admin/tabGoods/get/${params.id}`)
  },
  //保存、修改  skipNulls: true  完全跳过值为 null 的键不解析
  saveOrUpdate(params){
    // console.log("----我使用新的了-----"+params)
    return axios.post(`${base.bs}/admin/tabGoods/set`,qs.stringify(params,{indices: false,skipNulls: true}));
  },
  //根据id删除单个
  del(params){
    return axios.get(`${base.bs}/admin/tabGoods/del/${params.id}`)
  },
  //获取已上传附件
  getFilesList(params){
    return axios.get(`${base.bs}/admin/sys/tabFiles/getList/${params.dataid}`)
  },

  //批量删除附件
  delFilesBatch(params){
    // console.log("----我使用新的了-----"+params)
    return axios.post(`${base.bs}/admin/sys/tabFiles/delBatch`,qs.stringify(params, { indices: false }));
  },
}
// 导出接口
export  default myAllWork;




// WEBPACK FOOTER //
// ./src/request/api/goods.js